import { createErrorResultExt, SimpleResult } from "../dto";
import { RideSoftValidationErrorType } from "../enums";
import {
  freezeTimeToCancelRideError,
  freezeTimeToChangeRideError,
  freezeTimeToCreateRideError,
} from "../helpers/ride";
import type { TTranslationParams } from "../models";
import type {
  IHardValidationErrorLike,
  TFreezeTimeParams,
} from "./soft-hard-validation.models";

export const mapHardValidationErrorToResult = <T = unknown>(
  validationError: IHardValidationErrorLike,
): SimpleResult<T> => {
  const { type, message, additional } = validationError;
  const params = additional as TFreezeTimeParams;
  if (type === RideSoftValidationErrorType.SupplierFreezeTimeToChangeRide) {
    return freezeTimeToChangeRideError(params) as SimpleResult<T>;
  }
  if (type === RideSoftValidationErrorType.SupplierFreezeTimeToCreateRide) {
    return freezeTimeToCreateRideError(params) as SimpleResult<T>;
  }
  if (type === RideSoftValidationErrorType.SupplierFreezeTimeToCancelRide) {
    return freezeTimeToCancelRideError(params) as SimpleResult<T>;
  }
  return createErrorResultExt({
    translationKey: message,
    translationParams: additional as TTranslationParams,
  }) as SimpleResult<T>;
};
